import gql from 'graphql-tag';

/**
 * @returns {gql fragment}
 */

const ProviderFragment = gql`
  fragment ProviderFragment on TransferProvider {
    company {
      name
    }
    supportPhoneMain
  }
`;

export default ProviderFragment;



// WEBPACK FOOTER //
// ./src/apolloConst/fragments/Provider.js